import type { IconPrimitives, IconProps } from './types';

export const buildAdminNavIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => {
  const HomesIcon = ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 33 32' fill='none' {...props}>
      <Path
        d='M3.47059 18.7017C3.47059 20.5264 3.47059 28.8929 3.47059 31.0547H20.7647C20.7647 27.6576 20.7647 20.3223 20.7647 18.7017M1 21.1723L12.1176 10.0547L23.2353 21.1723M9.02941 31.0547V22.4076C10.8824 22.4076 12.7353 22.4076 15.2059 22.4076V31.0547'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M17.8955 7.22137C17.8955 8.14492 17.8955 10.6781 17.8955 13.0677M20.9954 16.1103H30.3399C30.3399 13.6658 30.3399 8.3875 30.3399 7.22137M16.1177 8.99915L24.1177 0.999146L32.1177 8.99915M21.8955 16.1103V9.88803C23.2288 9.88803 24.5621 9.88803 26.3399 9.88803V16.1103'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  );

  return {
    // ── Streamline-Cyber icons (2026 Kai Styleguide) ────────────────────────
    DashboardIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
        <Path d='M9.5 1.5H0.5V10.5H9.5V1.5Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
        <Path d='M22.5 1.5H13.5V10.5H22.5V1.5Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
        <Path d='M9.5 14.5H0.5V23.5H9.5V14.5Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
        <Path d='M22.5 14.5H13.5V23.5H22.5V14.5Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
      </Svg>
    ),
    HomesIcon,
    PropertiesIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='8.5 9.4 23.7 23.7' fill='none' {...props}>
        <Path
          d='M16.1212 18.0295L23.5606 11.52L31 18.0295V24.5389C31 25.0322 31 25.9028 31 26.3988C30.504 26.3988 29.6334 26.3988 29.1401 26.3988H17.9811C17.4878 26.3988 16.2452 26.3988 16.1212 26.3988C16.1212 26.0429 16.1212 25.0322 16.1212 24.5389V18.0295Z'
          stroke={color}
          strokeMiterlimit={16}
        />
        <Path
          d='M9.63788 20.6817L17.0773 14.1722L24.5166 20.6817V27.1912C24.5166 27.6844 24.5166 28.555 24.5166 29.051C24.0207 29.051 23.15 29.051 22.6568 29.051H11.4977C11.0045 29.051 9.76187 29.051 9.63788 29.051C9.63788 28.6951 9.63788 27.6844 9.63788 27.1912V20.6817Z'
          stroke={color}
          strokeMiterlimit={16}
        />
      </Svg>
    ),
    MarketsIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
        <Path d='M12 23.5L4.5 11V5L12 0.5L19.5 5V11L12 23.5Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
        <Path
          d='M8.5 6.59207L12 4.51807L15.5 6.59207V10.4441L12 12.5181L8.5 10.4441V6.59207Z'
          stroke={color}
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </Svg>
    ),
    ContractorsIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='14.5 7.7 25.6 25.6' fill='none' {...props}>
        <Path
          d='M28.2465 9L23.2466 13.9999L33.7463 24.4996L38.7462 19.4997L28.2465 9Z'
          stroke={color}
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M29.4973 20.2498L17.7473 31.9998L16.2473 31.4998L15.7473 29.9998L27.4973 18.2498'
          stroke={color}
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M32.4973 13.2498L34.2473 11.4998L36.2473 13.4998L34.4973 15.2498'
          stroke={color}
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </Svg>
    ),
    ProductsIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='13.2 7.7 25.6 25.6' fill='none' {...props}>
        <Path d='M25.5 17L14.5 13L26 9L37.5 13L25.5 17Z' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
        <Path d='M37.5 13V27L25.5 32L14.5 27V13' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
        <Path d='M25.5 17V32' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
        <Path d='M20 15L31.625 10.957' stroke={color} strokeMiterlimit={10} strokeLinecap='round' strokeLinejoin='round' />
      </Svg>
    ),
    TemplatesIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='13.3 7.8 24.4 24.4' fill='none' {...props}>
        <Path d='M36.5 9H14.5V31H36.5V9Z' stroke={color} strokeMiterlimit={10} />
        <Path d='M14.5 15H36.5' stroke={color} strokeMiterlimit={10} />
        <Path d='M21.5 15V31' stroke={color} strokeMiterlimit={10} />
        <Path d='M21.5 23H36.5' stroke={color} strokeMiterlimit={10} />
      </Svg>
    ),
    UsersIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
        <Path d='M11.5 13L7.5 14.5L3.5 13V7.5L7.5 6L11.5 7.5V13Z' stroke={color} strokeMiterlimit={10} />
        <Path d='M14.5 21.5V17L7.5 15.5L0.5 17V21.5' stroke={color} strokeMiterlimit={10} />
        <Path d='M21.5 13L18.5 14.5L15.5 13V9.5L18.5 8L21.5 9.5V13Z' stroke={color} strokeMiterlimit={10} />
        <Path d='M23.5 21.5V17L18.5 15.5L16.5 16.1' stroke={color} strokeMiterlimit={10} />
      </Svg>
    ),
    OrgSettingsIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
      <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
        <Path d='M12.5 7.5H20.5' stroke={color} strokeMiterlimit={10} />
        <Path d='M2.5 7.5H5.5' stroke={color} strokeMiterlimit={10} />
        <Path d='M10.5 17.5H2.5' stroke={color} strokeMiterlimit={10} />
        <Path d='M20.5 17.5H17.5' stroke={color} strokeMiterlimit={10} />
        <Path d='M7.232 10.5L5.5 7.5L7.232 4.5H10.768L12.5 7.5L10.768 10.5H7.232Z' stroke={color} strokeMiterlimit={10} />
        <Path d='M12.232 20.5L10.5 17.5L12.232 14.5H15.768L17.5 17.5L15.768 20.5H12.232Z' stroke={color} strokeMiterlimit={10} />
      </Svg>
    ),
  };
};
